import petrovich from 'petrovich';
import type { InputType } from 'petrovich';
import { POSITION_MORPH_DICTIONARY, MorphCase } from './position-dictionary';

const normalizePositionKey = (value: string) =>
  value.trim().replace(/\s+/g, ' ').toLowerCase();

const matchCase = (sample: string, value: string) => {
  if (sample === sample.toUpperCase()) {
    return value.toUpperCase();
  }
  if (sample === sample.toLowerCase()) {
    return value.toLowerCase();
  }
  return value;
};

export function morpher(word: string, morph: string, type: InputType) {
  let wordMorph;
  switch (morph) {
    case 'именительный':
      morph = 'nominative';
      break;
    case 'родительный':
      morph = 'genitive';
      break;
    case 'дательный':
      morph = 'dative';
      break;
    case 'винительный':
      morph = 'accusative';
      break;
    case 'творительный':
      morph = 'instrumental';
      break;
    case 'предложный':
      morph = 'prepositional';
      break;
  }
  if (type === 'ФИО') {
    let person = {
      middle: '',
      first: '',
      last: '',
    };
    const arr = word.trim().split(' ');
    if (arr.length == 3) {
      person['middle'] = arr[2];
    }
    if (arr.length >= 2) {
      person['first'] = arr[1];
    }
    if (arr.length >= 1) {
      person['last'] = arr[0];
    }
    const personMorph = petrovich(person, morph);

    wordMorph =
      personMorph['last'] +
      ' ' +
      personMorph['first'] +
      ' ' +
      personMorph['middle'];
  } else if (type === 'Должность') {
    const dictionaryEntry = POSITION_MORPH_DICTIONARY[normalizePositionKey(word)];
    const dictionaryValue = dictionaryEntry?.[morph as MorphCase];
    if (dictionaryValue) {
      return matchCase(word, dictionaryValue);
    }
    let position = {
      gender: 'male',
      first: word.trim(),
    };
    wordMorph = petrovich(position, morph)['first'];
  }
  return wordMorph;
}
